import { useState } from "react";
import { toast } from "sonner";
import { CircleNotch } from "@phosphor-icons/react";
import { formatApiErrorDetail } from "@/lib/api";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

export function DeleteRuleDialog({ rule, onCancel, onConfirm }) {
  const [busy, setBusy] = useState(false);

  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await onConfirm(rule); } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Couldn't delete that rule."); } finally { setBusy(false); }
  };

  return (
    <AlertDialog open={!!rule} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent data-testid="receipt-rule-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this rule?</AlertDialogTitle>
          <AlertDialogDescription>
            Rowan will stop suggesting <strong>{rule?.category}</strong> for "{rule?.match}"{rule?.business_name ? ` in ${rule.business_name}` : ""}.
            Transactions and receipts you've already posted keep their categories.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="receipt-rule-delete-cancel">Keep rule</AlertDialogCancel>
          <AlertDialogAction onClick={confirm} disabled={busy} data-testid="receipt-rule-delete-confirm" style={{ background: "#B23B1F" }}>
            {busy ? <CircleNotch size={14} className="animate-spin" /> : "Delete rule"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
